import React, { Component } from 'react'
import { useParams, NavLink, Navigate } from 'react-router'
import './Edit.css'
import BackIcon from '../Icons/Back.svg'
import API from '../API'

function ValidName(Name) {
	Name = Name.replace(/[^A-Za-z0-9_]/g, '')
	return Name
}

class Edit extends Component {
	constructor(props) {
		super(props)
		this.Name = this.props.params.Name
		if (this.Name == '_')
			this.Name = ''
		this.state = {}
		this.ExistsCheck = {}
		this.Exists = {}
		this.Load()
	}
	async Load() {
		if (this.Name)
			this.Data = await API('Projects/Get', this.Name)
		else
			this.Data = {Active: true}
		this.setState(this.Data)
	}
	onSubmit(event) {
		event.preventDefault()
		event.stopPropagation()
		this.setState({Submitting: true})
		const Properties = {
			Name: event.currentTarget.elements.Name.value,
			Description: event.currentTarget.elements.Description.value,
			PublicIPv4: event.currentTarget.elements.PublicIPv4.value,
			PublicIPv6: event.currentTarget.elements.PublicIPv6.value,
			Active: event.currentTarget.elements.Active.checked,
		}
		API('Projects/Save', this.Name, Properties).then(Result=>{
			this.setState({Submitting: false})
			if (Result === true)
				this.setState({Redirect: <Navigate to="/ui/project" replace={true} />})
		})
	}
	Delete(event) {
		event.preventDefault()
		event.stopPropagation()
	}
	async CheckExists(Name) {
		console.log('CheckExists', Name)
		if (this.ExistsCheck[Name] === undefined) {
			this.ExistsCheck[Name] = API('Projects/Get', Name)
			this.Exists[Name] = !!(await this.ExistsCheck[Name])
		}
		this.forceUpdate()
	}
	render() {
		let NameClasses = []
		if (this.state.Name!=this.Name) {
			NameClasses.push('Changed')
			console.log('Exists', this.state.Name, this.Exists[this.state.Name])
			if (this.Exists[this.state.Name]) {
				NameClasses.push('Error')
			}
		}
		NameClasses = NameClasses.join(' ')
		return this.Data?(
			<div className="EditProject">
				<h1><NavLink to="/ui/projects"><img className="Icon" src={BackIcon} /></NavLink>&nbsp; {this.Name?'Edit':'New'} Project</h1>
				<form onSubmit={this.onSubmit.bind(this)}>
					<field>
						<label>Project Name</label>
						<input id="Name" className={NameClasses} value={this.state.Name} onInput={(e)=>{this.setState({Name:ValidName(e.target.value)});this.CheckExists(e.target.value)}} />
					</field>
					<div className="Row">
						<label>Project Active</label>
						<div className="Right">
							<input id="Active" type="checkbox" checked={this.state.Active} onInput={(e)=>{this.state.Active=!this.state.Active;this.forceUpdate()}} />
						</div>
					</div>
					<field>
						<label>Project Description</label>
						<textarea id="Description" className={this.state.Description==this.Data?.Description?"":'Changed'} value={this.state.Description} onInput={(e)=>this.setState({Description:e.target.value})} ></textarea>
					</field>
					<field>
						<label>Public IPv4</label>
						<input id="PublicIPv4" className={this.state.PublicIPv4==this.Data.PublicIPv4?"":'Changed'} value={this.state.PublicIPv4} onInput={(e)=>this.setState({PublicIPv4:e.target.value})} />
					</field>
					<field>
						<label>Public IPv6</label>
						<input id="PublicIPv6" className={this.state.PublicIPv6==this.Data.PublicIPv6?"":'Changed'} value={this.state.PublicIPv6} onInput={(e)=>this.setState({PublicIPv6:e.target.value})} />
					</field>
					<div className="Row Footer">
						<button class="Outline" style={{display:this.Name?'inline-block':'none'}} onClick={this.Delete.bind(this)}>Delete</button>
						<button class="Right" disabled={this.state.Submitting} type="submit">Save</button>
					</div>
				</form>
				{this.state.Redirect}
			</div>
		):(<div className="EditProject Loading">Loading...</div>)
	}
}
function withRouter(Component) {
	return props => <Component params={useParams()} />;
}
export default withRouter(Edit)
